export const GET_MESSAGE = 'GET_MESSAGE'
export const UPDATE_MESSAGE = 'UPDATE_MESSAGE'
export const UPDATE_MESSAGE_STORE = 'UPDATE_MESSAGE_STORE'
export const UPDATE_MESSAGE_FAILED = 'UPDATE_MESSAGE_FAILED'
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE'
export const SEND_MESSAGE = 'SEND_MESSAGE'
export const LOADING_MESSAGE = 'LOADING_MESSAGE'
export const FAILED_MESSAGE = 'FAILED_MESSAGE'
export const SUCCESS_MESSAGE_CLEAR = 'SUCCESS_MESSAGE_CLEAR'
export const MESSAGE_WRITE = 'MESSAGE_WRITE'
export const NOTE_CREATE = 'NOTE_CREATE'
export const GET_MY_NOTE = 'GET_MY_NOTE'
export const WRITE_MESSAGE_UPDATE= 'WRITE_MESSAGE_UPDATE';